import { Select, Spin } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";
import { useToast } from "../../../../contexts/ToastContext";

// eslint-disable-next-line no-unused-vars
const SelectYear = ({ selectedCarModel, setSelectedCarModel, selectedYear, setSelectedYear, t }) => {
    const toast = useToast();
    const [loading, setLoading] = useState(false);
    const [years, setYears] = useState([]);
    const [carModels, setCarModels] = useState([]);

    const fetchCarModels = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `https://public.opendatasoft.com/api/explore/v2.1/catalog/datasets/all-vehicles-model/records?select=make%2C%20model%2C%20year%2C%20vclass%2C%20fueltype1%2C%20trany&where=search(model,"${selectedCarModel?.model}")&order_by=year%20DESC&limit=-1&refine=make%3A${selectedCarModel?.make}&refine=model%3A${selectedCarModel?.model}`,
            );

            if (response?.data?.results) {
                setCarModels(response?.data?.results);

                // Extract unique years
                const uniqueYears = [...new Set(response.data.results.map((item) => Number.parseInt(item.year, 10)))];

                // Sort years in descending order (most recent first)
                uniqueYears.sort((a, b) => b - a);

                // Create year options
                const yearOptions = uniqueYears.map((year) => ({
                    value: year,
                    label: `${year}`,
                }));

                setYears(yearOptions);
            }
        } catch (_error) {
            // console.error(_error);
            toast.error({ message: t("failedToFetchYears") });
        } finally {
            setLoading(false);
        }
    }, [toast, selectedCarModel, t]);

    useEffect(() => {
        if (selectedCarModel?.model && selectedCarModel?.make) {
            fetchCarModels();
        }
    }, [selectedCarModel, fetchCarModels]);

    const handleYearChange = (value) => {
        setSelectedYear(value);

        // When a year is selected, find the full car model data for that year
        if (value && carModels.length > 0) {
            const selectedYearModel = carModels.find((car) => Number.parseInt(car.year, 10) === value);
            if (selectedYearModel) {
                // Update car model with all details including vclass, fueltype1, and trany
                setSelectedCarModel({
                    ...selectedCarModel,
                    year: selectedYearModel.year,
                    vclass: selectedYearModel.vclass,
                    fueltype1: selectedYearModel.fueltype1,
                    trany: selectedYearModel.trany,
                });
            }
        }
    };

    return (
        <div>
            <p className="text-md font-medium mb-2">
                {t("car")} {t("year")}
            </p>
            {loading ? (
                <div className="flex justify-center my-4">
                    <Spin size="small" />
                </div>
            ) : (
                <Select
                    showSearch
                    placeholder={t("selectYear")}
                    optionFilterProp="children"
                    onChange={handleYearChange}
                    value={selectedCarModel.year}
                    className="w-full"
                    options={years}
                    filterOption={(input, option) => (option?.label ?? "").toString().includes(input)}
                />
            )}
        </div>
    );
};

SelectYear.propTypes = {
    selectedCarModel: PropTypes.object,
    setSelectedCarModel: PropTypes.func,
    selectedCompany: PropTypes.string,
    selectedYear: PropTypes.number,
    setSelectedYear: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default SelectYear;
